/**
 * Created by muratzengin on 29/03/16.
 */
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { AppSettings } from '@slarys/ufe-config';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private __tags: any;
  private __tag: any;
  private dataObs$ = new ReplaySubject(1);
  private getTagsByCategoryRequested = false;
  private hasBeenRequested = false;
  private requestedCalls = [];
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  get tag(): any {
    return this.__tag;
  }

  set tag(value) {
    this.__tag = value;
  }

  get tags(): any {
    return this.__tags;
  }

  set tags(value) {
    this.__tags = value;
  }
  constructor(private httpClient: HttpClient) {}

  public getTagsCategorized() {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-all-categorized');
  }

  public getMainTags() {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/main-tags');
  }

  public getTagsCategorizedInHeader() {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-all-categorized-header');
  }

  public getTagsTop50() {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-top-50');
  }

  public getTagsTree() {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-tree');
  }

  public createNewTag(tag) {
    return this.httpClient
      .post<any>(
        AppSettings.API_ENDPOINT + '/tags/create-new-tag',
        tag,
        this.httpOptions
      )
      .pipe
      // catchError
      ();
  }
  public getTagsTreeById(id): Observable<any> {
    return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-tree/' + id);
  }

  public getTagsByCategory(id?, forceRefresh?: boolean) {
    let dataObs$ = new ReplaySubject(1);

    // If the Subject was NOT subscribed before OR if forceRefresh is requested
    const alreadyCalled = _.find(this.requestedCalls, function(call) {
      return call.id === id;
    });

    if (!alreadyCalled || forceRefresh) {
      this.getTagsByCategoryRequested = true;
      dataObs$ = new ReplaySubject(1);
      this.httpClient
        .get(AppSettings.API_ENDPOINT + '/tags/tags-by-category?id=' + id)
        .subscribe(
          (data) => {
            (<any>dataObs$).id = id;
            dataObs$.next(data);
            this.requestedCalls.push(dataObs$);
          },
          error => {
            dataObs$.error(error);
            // Recreate the Observable as after Error we cannot emit data anymore
            dataObs$ = new ReplaySubject(5);
          }
        );
    }
    const dataObs = _.find(this.requestedCalls, function(call) {
      return call.id === id;
    });
    return dataObs || dataObs$;

    // return this.dataObs$;
    // return this.httpClient.get(AppSettings.API_ENDPOINT + '/tags/tags-by-category?id=' + id);
  }

  public getTags(page?: string, forceRefresh?: boolean, pageSize?: number) {
    // If the Subject was NOT subscribed before OR if forceRefresh is requested
    if (!this.hasBeenRequested || forceRefresh) {
      this.hasBeenRequested = true;
      let url = AppSettings.API_ENDPOINT + '/tags/tags-all?';
      if (page) {
        url += 'page=' + page;
      } else {
        url += 'page=' + 1;
      }
      if (pageSize) {
        url += '&pageSize=' + pageSize;
      }
      this.httpClient.get(url)
        .subscribe(
          (data) => {
            this.dataObs$.next(data);
          },
          error => {
            this.dataObs$.error(error);
            // Recreate the Observable as after Error we cannot emit data anymore
            this.dataObs$ = new ReplaySubject(1);
          });
    }

    return this.dataObs$;
  }
  // public getTags(): Observable<any> {
  //   return this.__http.get('http://localhost:3005/api/tags-all')
  //   // Call map on the response observable to get the parsed people object
  //     .pipe(map(res => res.json()));
  // }

  public getTag(id: string): Observable<any> {
    return (
      this.httpClient
        .get(AppSettings.API_ENDPOINT + '/tags/' + id));
  }

  public getTagsRaw(): Observable<any> {
    return (
        this.httpClient
            .get(AppSettings.API_ENDPOINT + '/tags/raw'));
  }
}
